import { useEffect } from 'react';
import { getSocket } from '../Utils/SocketService';
import { useAppDispatch } from '../store/hooks';
import { updateDriverLocations, setTrackingConnected, clearDriverLocations } from '../store/driverTracking.store';

const useDriverTracking = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const socket = getSocket();

    if (!socket.connected) {
      socket.connect();
    }

    const onConnect = () => dispatch(setTrackingConnected(true));
    const onDisconnect = () => dispatch(setTrackingConnected(false));

    const onLocationsUpdate = (data: { locations: any[] }) => {
      dispatch(updateDriverLocations({ locations: data.locations }));
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('driver_locations_update', onLocationsUpdate);

    if (socket.connected) {
      dispatch(setTrackingConnected(true));
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('driver_locations_update', onLocationsUpdate);
      dispatch(clearDriverLocations());
    };
  }, [dispatch]);
};

export default useDriverTracking;
